import { render } from "./message-input.vue?vue&type=template&id=1cf63207&lang=pug"
import script from "./message-input.vue?vue&type=script&lang=js"
export * from "./message-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__